<template>
<div class="page">
  <div class="page-content">
    <div class="layoutTop"/>

    <b-container fluid class="text-spacing-support">
      <b-row class="justify-content-start">
        <b-col md="3" class="showLargeScreenOnly">
          <f7-button md="3" class="button-action milkyBlockBlack keyboard-accessible"
                  @click="onRefresh()"
                  @keydown="handleKeyDown($event, onRefresh)"
                  :aria-label="$t('common.rfrsh')"
                  role="button"
                  tabindex="0">
            <f7-icon f7="refresh" aria-hidden="true"></f7-icon>
            <span class="fab-label">{{ $t('common.rfrsh') }}</span>
          </f7-button>
        </b-col>
        <b-col md="3">
          <f7-button md="3" class="button-action milkyBlockBlack keyboard-accessible"
            @click="addAccount"
            @keydown="handleKeyDown($event, addAccount)"
            :disabled="!canAddAccount()"
            :aria-label="currentType === '1' ? $t('administration.company_add') : $t('administration.user_add')"
            :aria-describedby="!canAddAccount() ? 'add-disabled-msg' : null"
            role="button"
            tabindex="0">
            <f7-icon f7="add" aria-hidden="true"></f7-icon>
            <span v-if="currentType === '1'" class="fab-label">{{ $t('administration.company_add') }}</span>
            <span v-if="currentType === '2'" class="fab-label">{{ $t('administration.user_add') }}</span>
          </f7-button>
          <div id="add-disabled-msg" class="sr-only" v-if="!canAddAccount()">
            {{ $t('administration.add_account_disabled_reason') }}
          </div>
        </b-col>
      </b-row>

      <b-row>
        <div class="col-md-12">
          <div class="adminUsersCompaniesListHeader" role="tablist" aria-label="Gestion des comptes">
            <f7-grid no-gutter>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class="pilotageLink border-top-left-radius-10px keyboard-accessible"
                  :class="{tabActive: currentType === '2', tabUnactive: currentType !== '2'}"
                  tab-link=".usersTab"
                  @click="changeCurrentType('2')" 
                  @keydown="handleKeyDown($event, () => changeCurrentType('2'))"
                  active
                  role="tab"
                  :aria-selected="currentType === '2'"
                  :aria-controls="'users-tabpanel'"
                  :tabindex="currentType === '2' ? '0' : '-1'"
                  :aria-label="$t('administration.users_list')"
                  id="users-tab">
                  {{ $t('administration.users_list') }}
                  <span class="sr-only" v-if="currentType === '2'"> - Onglet actif</span>
                </f7-link>
              </f7-col>
              <f7-col width="50" class="pilotageTabController">
                <f7-link class="pilotageLink border-top-left-radius-10px keyboard-accessible"
                  :class="{tabActive: currentType === '1', tabUnactive: currentType !== '1'}"
                  tab-link=".companiesTab"
                  @click="changeCurrentType('1')"
                  @keydown="handleKeyDown($event, () => changeCurrentType('1'))"
                  role="tab"
                  :aria-selected="currentType === '1'"
                  :aria-controls="'companies-tabpanel'"
                  :tabindex="currentType === '1' ? '0' : '-1'"
                  :aria-label="$t('administration.companies_list')"
                  id="companies-tab">
                  {{ $t('administration.companies_list') }}
                  <span class="sr-only" v-if="currentType === '1'"> - Onglet actif</span>
                </f7-link>
              </f7-col>
            </f7-grid>
          </div>
        </div>
      </b-row>

      <b-row>
        <b-col>
          <f7-tabs>
            <f7-tab class="usersTab" active 
              role="tabpanel" 
              id="users-tabpanel"
              :aria-labelledby="'users-tab'"
              :aria-hidden="currentType !== '2'">
              <f7-searchbar
                class="webdatalist keyboard-accessible"
                :cancel-link="$t('common.cncl')"
                :placeholder="$t('common.search_users')"
          			search-list="#users-list"
                @searchbar:search="onUsersSearch"
                @searchbar:clear="onUsersClear"
                @keydown="handleSearchKeyDown"
                :aria-label="$t('common.search_users')"
                role="searchbox"
                aria-describedby="users-search-help">
              </f7-searchbar>
              <div id="users-search-help" class="sr-only">
                {{ $t('common.search_users_help') }}
              </div>
              <div class="itemList">
                <spinner v-if="usersList.length === 0"></spinner>
                <users-list v-else :users="usersList"></users-list>
              </div>
            </f7-tab>
            <f7-tab class="companiesTab"
              role="tabpanel" 
              id="companies-tabpanel"
              :aria-labelledby="'companies-tab'"
              :aria-hidden="currentType !== '1'">
              <f7-searchbar
                class="webdatalist keyboard-accessible"
                :cancel-link="$t('common.cncl')"
                :placeholder="$t('common.search_companies')"
          			search-list="#companies-list"
                @searchbar:search="onCompaniesSearch"
                @searchbar:clear="onCompaniesClear"
                @keydown="handleSearchKeyDown"
                :aria-label="$t('common.search_companies')"
                role="searchbox"
                aria-describedby="companies-search-help">
              </f7-searchbar>
              <div id="companies-search-help" class="sr-only">
                {{ $t('common.search_companies_help') }}
              </div>
              <div class="itemList">
                <spinner v-if="companiesList.length === 0"></spinner>
                <companies-list v-else :companies="companiesList"></companies-list>
              </div>
            </f7-tab>
          </f7-tabs>
        </b-col>
      </b-row>

    </b-container>
    <div class="toolbarPageBottomBlank"></div>
  </div>
</div>
</template>

<script>
import spinner from '@/components/common/spinner.vue'

import CompaniesList from '@/pages/administration/CompaniesList.vue'
import UsersList from '@/pages/administration/UsersList.vue'

import {loadPage} from '@/helpers/routing'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'Users',
  components: {
    'companies-list': CompaniesList,
    'spinner': spinner,
    'users-list': UsersList
  },
  props: {

  },
  data () {
    return {
      companies: [],
      companiesFilterBy: '',
      companiesList: [],
      correctAccent: [],
      currentType: '2',
      users: [],
      usersFilterBy: '',
      usersList: [],
      usersOrCompanies: []
    }
  },
  created () {
    var tmpAccent = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÖØòóôõöøÈÉÊËèéêëÇçÌÍÎÏìíîïÙÚÛÜùúûüÿÑñ'
    var tmpWithoutAccent = 'aaaaaaaaaaaaooooooooooooeeeeeeeecciiiiiiiiuuuuuuuuynn'
    var accent = tmpAccent.split('')
    var withoutAccent = tmpWithoutAccent.split('')
    var i = -1
    while (accent[++i]) {
      this.correctAccent[accent[i]] = withoutAccent[i]
    }
    this.correctAccent['Œ'] = 'OE'
    this.correctAccent['œ'] = 'oe'
    let that = this
    this.$engine.firstOn().accounts.getUserAccountsAll()
    .then(resp => {
      that.usersOrCompanies = resp.data.userAccounts
      that.usersOrCompanies.forEach((user, key) => {
        if (user.type === '1') {
          that.companies[user.id] = user
        } else if (user.type === '2') {
          that.users[user.id] = user
        }
      })
      that.setUsers()
      that.setCompanies()
    })
    .catch(error => {
      errorMessageAlert(error, that, that.$i18n)
    })
  },
  mounted () {
  },
  beforeDestroy () {

  },
  methods: {
    addAccount () {
      loadPage(this, {
        url: '/administration/accountAdd/' + this.currentType
      })
    },
    canAddAccount () {
      return (this.$engine.firstOn().user.get().rights.admin_user_add === '1')
    },
    changeCurrentType (type) {
      if (this.currentType !== type) {
        this.currentType = type
        // Annoncer le changement aux technologies d'assistance
        this.announceTabChange(type)
      }
    },
    // RGAA 10.13 & 10.14 - Gestion du clavier et des contenus additionnels
    handleKeyDown (event, action) {
      // Gérer les touches Entrée et Espace pour l'activation
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        if (typeof action === 'function') {
          action()
        }
      }
      // Gérer la touche Échap pour fermer les contenus additionnels
      if (event.key === 'Escape') {
        this.closeAdditionalContent()
      }
    },
    handleSearchKeyDown (event) {
      // Gestion spécifique pour les barres de recherche
      if (event.key === 'Escape') {
        // Effacer la recherche si Échap est pressé
        if (this.currentType === '2') {
          this.onUsersClear()
        } else {
          this.onCompaniesClear()
        }
      }
    },
    announceTabChange (type) {
      // Annoncer le changement d'onglet pour les lecteurs d'écran
      const message = type === '2' ? 
        this.$t('administration.users_tab_selected') : 
        this.$t('administration.companies_tab_selected')
      
      // Créer un élément temporaire pour l'annonce
      const announcement = document.createElement('div')
      announcement.setAttribute('aria-live', 'polite')
      announcement.setAttribute('aria-atomic', 'true')
      announcement.className = 'sr-only'
      announcement.textContent = message
      
      document.body.appendChild(announcement)
      
      // Supprimer l'élément après l'annonce
      setTimeout(() => {
        document.body.removeChild(announcement)
      }, 1000)
    },
    closeAdditionalContent () {
      // Fermer tous les contenus additionnels ouverts
      const additionalContents = document.querySelectorAll('.additional-content, .dropdown-content')
      additionalContents.forEach(content => {
        content.style.display = 'none'
        content.style.visibility = 'hidden'
        content.style.opacity = '0'
      })
    },
    onCompaniesClear () {
      this.companiesFilterBy = ''
    },
    onUsersClear: function () {
      this.usersFilterBy = ''
    },
    onRefresh () {
      let that = this
      this.companies = []
      this.users = []
      this.$engine.firstOn().accounts.getUserAccountsAll()
      .then(resp => {
        that.usersOrCompanies = resp.data.userAccounts
        that.usersOrCompanies.forEach((user, key) => {
          if (user.type === '1') {
            that.companies[user.id] = user
          } else if (user.type === '2') {
            that.users[user.id] = user
          }
        })
        that.setUsers()
        that.setCompanies()
      })
      .catch(error => {
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    onCompaniesSearch (query, found) {
      this.companiesFilterBy = query
      this.setCompanies()
    },
    onUsersSearch (query, found) {
      this.usersFilterBy = query
      this.setUsers()
    },
    orderKeys (obj) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      return after
    },
    setCompanies (index = 1) {
      var companiesList = {}
      let companiesFilterBy = this.replaceAccent(this.companiesFilterBy)
      for (let companyPlusKey of Object.entries(this.companies)) {
        let company = companyPlusKey[1]
        let name = this.replaceAccent(company.Name)
        if (name.toLowerCase().includes(companiesFilterBy.toLowerCase())) {
          var firstLetter = name.substr(0, 1).toUpperCase()
          if (!companiesList.hasOwnProperty(firstLetter)) {
            companiesList[firstLetter] = []
          }
          companiesList[firstLetter].push({
            Id: company.id,
            Name: company.Name,
            Login: company.login
          })
          companiesList[firstLetter].sort((a, b) => {
            if (a === b) {
              return 0
            }
            return a.Name < b.Name ? -1 : 1
          })
        }
      }
      this.companiesList = this.orderKeys(companiesList)
    },
    setUsers (index = 1) {
      var listUsers = {}
      let usersFilterBy = this.replaceAccent(this.usersFilterBy)
      for (let userPlusKey of Object.entries(this.users)) {
        let user = userPlusKey[1]
        let name = this.replaceAccent(user.Name)
        if (name.toLowerCase().includes(usersFilterBy.toLowerCase())) {
          var firstLetter = name.substr(0, 1).toUpperCase()
          if (!listUsers.hasOwnProperty(firstLetter)) {
            listUsers[firstLetter] = []
          }
          listUsers[firstLetter].push({
            Id: user.id,
            Name: user.Name,
            Login: user.login,
            IdUserAccount: user.IdUserAccount
          })
          listUsers[firstLetter].sort((a, b) => {
            if (a === b) {
              return 0
            }
            return a.Name < b.Name ? -1 : 1
          })
        }
      }
      this.usersList = this.orderKeys(listUsers)
    },
    replaceAccent (strToTest) {
      if (!strToTest.length) {
        return strToTest
      }
      if (typeof strToTest === 'string') {
        var str = strToTest
        let correctAccent = this.correctAccent
        str = str.replace(/./g, function (i) {
          return (correctAccent[i]) ? correctAccent[i] : i
        })
        return str
      }
      return strToTest
    }
  }
}
</script>
